import React, { useMemo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { RootState } from '../../redux/rootState';
import DataTable from '../../Common/DataTable';
import { setLoader } from '../../redux/loaderSlice';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import { getJobOrderList } from './redux/sliceInspectionSummary';
import EndPoints from '../../Routes/EndPoints';

export default function JobOrderList() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();
  const { jobOrder } = useParams();
  const { isLoading, jobOrderList, jobOrderTotalData } = useSelector((state: RootState) => state.inspectionSummaryReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(getJobOrderList(params));
  };

  useEffect(() => {
    if (jobOrder) {
      setSearchQuery(jobOrder);
    } else setSearchQuery('');
  }, [jobOrder]);

  useEffect(() => {
    handleData();
  }, []);

  const columns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'jobOrder', label: 'Job Order #' },
    ],
    [],
  );

  const data = useMemo(() => jobOrderList?.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      action: 'edit',
      jobOrder: String(item),
      id: String(item),
    };
    return transformedDataItem;
  }), [jobOrderList]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleEdit = (id:string) => {
    window.open(`/${EndPoints.Inspection_Summary}/${id}`);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="Inspection Summary" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <DataTable
          data={data}
          columns={columns}
          totalRecords={jobOrderTotalData}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleData={handleData}
          handleEdit={handleEdit}
        />
      </Grid>
    </Grid>
  );
}
